<template>
  <v-container
    class="mb-7"
  >
    Work in progress
    <v-row
      v-for="(project, index) in projects"
      :key="index"
      :cols="12"
      :class="{'flex-row-reverse': index % 2 !== 1}"
    >
      <v-col
        cols="6"
      >
        <GalleryComponent :gallery="project.gallery "/>
      </v-col>
      <v-col
        cols="6"
      >
        <v-card
          :title="project.name"
          :text="project.description"
        >
          <v-card-actions>
            <v-chip
              v-for="tech in project.technologies"
              :key="tech"
              color="primary"
              class="mr-2"
            >
              {{ tech }}
            </v-chip>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import GalleryComponent from '@/components/Gallery'

export default {
  name: 'SchoolProjects',
  components: { GalleryComponent },
  data () {
    return {
      projects: [
        {
          name: 'Lorem Ipsum',
          description: 'lorem ipsum',
          technologies: [],
          gallery: [
            {
              image: '',
              caption: 'Caption'
            }
          ]
        }
      ]
    }
  }
}
</script>
